<template>
  <div class="settingSidebarNew">
    <el-menu 
      class="sidebarnew" 
      ref="menu" 
      :default-openeds="openedSubmenu"
      @open="handleOpen"
    >
      <div
        v-for="(menu,key) in menuList"
        :key="key"
      >
        <el-menu-item v-if="!menu.submenu">
          <router-link
            :to="{name: key}"
            class="link"
          >
            <i
              class="iconfont"
              :class="menu.icon"
            ></i>
            <el-tooltip effect="dark" :disabled="!tooltipFlag"  :content="menu.title" placement="right">
              <span @mouseenter="visibilityChange($event)" class="title">{{menu.title}}</span>
            </el-tooltip>
          </router-link>
        </el-menu-item>
        <el-submenu
          v-else
          :index="key"
        >
          <template slot="title">
            <div class="link">
              <i
                class="iconfont"
                :class="menu.icon"
              ></i>
              <el-tooltip  :content="menu.title" placement="right">

              </el-tooltip>
              <el-tooltip effect="dark" :disabled="!tooltipFlag"  :content="menu.title" placement="right">
                <span @mouseenter="visibilityChange($event)" class="title">{{menu.title}}</span>
              </el-tooltip>
            </div>
            <!-- <router-link class="link" :to="{path:menu.path}">
              <i
                class="iconfont"
                :class="menu.icon"
              ></i>
              <span class="title">{{menu.title}}</span>
            </router-link> -->
          </template>
          <el-menu-item
            v-for="submenu in menu.submenu"
            :key="submenu.name"
          >
            <router-link
              :to="{name: submenu.name}"
              class="link sublink"
            >
              <i
                class="iconfont"
                :class="submenu.icon"
              ></i>
              <el-tooltip effect="dark" :disabled="!tooltipFlag"  :content="submenu.title" placement="right">
                <span @mouseenter="visibilityChange($event)" class="title">{{submenu.title}}</span>
              </el-tooltip>
            </router-link>
          </el-menu-item>
        </el-submenu>
      </div>
    </el-menu>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { i18n } from "@/i18n";
import filter from "@/assets/js/filter";
export default {
  data() {
    return {
      openedOne: [],
      isCollapse: false,
      tooltipFlag: false,
      hasRedirected: false, // 防止重复跳转的标志位
    }
  },
  computed: {
		...mapState({
			menuList: state => {
        // console.log("[gnyy-role]", state.user.role);
        let route = state.user.route.find(route => {
            return route.path.endsWith('setting')
          })

        // console.log('【route-sidebarnew】', route);
        // let hostname=window.location.hostname

        let menu = {}
        route.children.forEach(ele => {
          if (!ele.meta) return
          // 非中文环境下隐藏发票相关路由
          if (i18n.locale !== 'zh_CN' && (ele.path == 'billingList' || ele.path == 'billingHistory')) return;

          // 过滤掉个人信息路由 =====
          if (ele.path == 'personalBasic') return;

          // 暂时过滤掉告警管理路由(待调试) =====
          // if (ele.path == 'alarmform') return;
          // 暂时过滤掉报表管理路由(待调试) =====
          if (ele.path == 'reportexport') return;
          if (ele.path == 'reportsubscribe') return;

          // 经销商/管理员 过滤掉数采器管理路由 =====
          if (
            state.user.role == 1 && ele.path == 'datalogger' ||
            state.user.role == 2 && ele.path == 'datalogger' ||
            state.user.role == 3 && ele.path == 'datalogger'
          ) return;
          // 经销商/管理员 过滤掉辅助图表路由 =====
          if (
            state.user.role == 1 && ele.path == 'helpform' ||
            state.user.role == 2 && ele.path == 'helpform' ||
            state.user.role == 3 && ele.path == 'helpform'
          ) return;
          // 经销商/管理员/浏览者 过滤掉子账户路由 =====
          if (
            state.user.role == 1 && ele.path == 'browseAccount' ||
            state.user.role == 2 && ele.path == 'browseAccount' ||
            state.user.role == 2 && ele.path == 'browseAccount' ||
            state.user.role == 5 && ele.path == 'browseAccount'
          ) return;
          if (
            state.user.uidExtra!="4229333"&&state.user.uidExtra!="3022965"&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053" && ele.path == 'strategy'||
            state.user.uidExtra!="4229333"&&state.user.uidExtra!="3022965"&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053" && ele.path == 'UpgFirmware'||
            state.user.uidExtra!="4229333"&&state.user.uidExtra!="3022965"&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053" && ele.path == 'upgrade'
          )return;
          // 日月元自适应升级固件管理
          if (
            state.user.uidExtra!="57791"&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053" && ele.path == 'adaptiveFirmware'
          )return;
          // 日月元本地OTA升级策略
          if (
            state.user.uidExtra!="57791" && ele.path == 'energyStrategynew'||
            state.user.uidExtra!="57791" && ele.path == 'energyUpgrade' ||
            state.user.uidExtra!="57791"&& ele.path == 'energyFirmware'
          )return;
          // 日月元透传升级
          // if (
          //   ele.path == 'cloudsFirmware'&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053"&&state.user.uidExtra!="43955"&&state.user.uidExtra!="57791"
          //   // hostname != 'eg4.dessmonitor.com'&&ele.path == 'cloudsFirmware'&&state.user.uidExtra!="43812"&&state.user.uidExtra!="44053"&&state.user.uidExtra!="43955"&&state.user.uidExtra!="57791"
          // ) return;
          // 需求：厂家用户不要费率设置 （1|2|3）
          if (
            state.user.role == 1 && ele.path == 'rate' ||
            state.user.role == 2 && ele.path == 'rate' ||
            state.user.role == 3 && ele.path == 'rate'
          ) return;
          let val = sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false;
          if(state.user.role == 2&&val){
            let arr = sessionStorage.getItem("firstPageArr")?JSON.parse(sessionStorage.getItem("firstPageArr")):[]
            let arrElse = sessionStorage.getItem("secPageArr")?JSON.parse(sessionStorage.getItem("secPageArr")):[]
            let category = ele.meta.category
            if (category) {
              if(category=="recharge"){
                if(!menu[category]&&arr.includes('recharge_settings')) {
                  menu[category] = {
                    ...route.meta.category[category],
                    submenu: []
                  }
                }else{
                  menu[category] = {
                    ...route.meta.category[category],
                    submenu: []
                  }
                }
                if(ele.name=="adminNewRechargePay"&&arrElse.includes('data_recharge')){
                  menu[category].submenu.push({
                    name: ele.name,
                    title: ele.meta.title,
                    icon: ele.meta.icon,
                    path: ele.path,
                  })
                }else if(ele.name=="adminNewRechargeRecord"&&arrElse.includes('recharge_records')){
                  menu[category].submenu.push({
                    name: ele.name,
                    title: ele.meta.title,
                    icon: ele.meta.icon,
                    path: ele.path,
                  })
                }else{
                  menu[category].submenu.push({
                    name: ele.name,
                    title: ele.meta.title,
                    icon: ele.meta.icon,
                    path: ele.path,
                  })
                }
              }else {
                if (category) {
                // 尚未父路由，先创建
                if(!menu[category]) {
                  menu[category] = {
                    ...route.meta.category[category],
                    submenu: []
                  }
                }
                menu[category].submenu.push({
                  name: ele.name,
                  title: ele.meta.title,
                  icon: ele.meta.icon,
                  path: ele.path,
                })
              } 
              }
            } 
            else {
              if(ele.name=="adminNewFirmware"){
                if(arr.includes('default_firmware_upgrade')){
                  menu[ele.name] = {
                    ...ele.meta
                  }
                }
              }else{
                menu[ele.name] = {
                  ...ele.meta
                }
              }
            }
          }else{
            // 若为子路由，添加到父路由中
            let category = ele.meta.category

            if (category) {
              // 尚未父路由，先创建
              if(!menu[category]) {
                menu[category] = {
                  ...route.meta.category[category],
                  submenu: []
                }
              }
              menu[category].submenu.push({
                name: ele.name,
                title: ele.meta.title,
                icon: ele.meta.icon,
                path: ele.path,
              })
              // 定制日月元OTA升级修改文案
              // if(category=="strategynew" && state.user.uidExtra=="43955"){
              //    menu[category].title = i18n.t("strategy.mueas")
              //    if(ele.path == 'UpgFirmware'){
              //      console.log(ele);
              //      ele.meta.title = i18n.t("firmware.Firmware_List")
              //    }
              // }
            } 
            else {
              // 否则直接添加到路由表中
              menu[ele.name] = {
                ...ele.meta
              }
            }
          }
          
        })
        return menu
      },
      // 角色
      role: state => {
        return {
          id: state.user.role,
          name: filter.role(state.user.role).name,
          group: filter.role(state.user.role).group
        };
      }
    }),
    // 初始展开子菜单
    openedSubmenu() {
      return [this.$route.meta.category]
    }
  },
  mounted() {
    // 非中文环境下隐藏发票相关路由
    this.checkAndRedirect();
  },
  // beforeUpdate() {
  //   this.checkAndRedirect();
  // },
  watch: {
    //非中文环境下隐藏发票相关路由 监听路由变化，重置标志位
    '$route'(to, from) {
      console.log('route changed',to, from);
      this.hasRedirected = false;
    }
  },
  methods: {
    //非中文环境下隐藏发票相关路由 检查并跳转到第一个可用菜单
    checkAndRedirect() {
      // 如果已经跳转过了，不再重复跳转
      if (this.hasRedirected) return;
      
      const currentRouteName = this.$route.name;
      const isBillingRoute = currentRouteName === 'generalNewBillingList'|| currentRouteName === 'generalNewBillingHistory';
      const isNonChinese = i18n.locale !== 'zh_CN';
      
      // 如果是非中文且当前在账单页面，且 menuList 不为空
      if (isNonChinese && isBillingRoute && this.menuList && Object.keys(this.menuList).length > 0) {
        this.hasRedirected = true; // 设置标志位
        this.$nextTick(() => {
          this.redirectToFirstMenu();
        });
      }
    },
    //非中文环境下隐藏发票相关路由 跳转到 menuList 的第一个可用路由
    redirectToFirstMenu() {
      const menuList = this.menuList;
      if (!menuList || Object.keys(menuList).length === 0) return;
      
      // 获取 menuList 的第一个 key
      const firstKey = Object.keys(menuList)[0];
      const firstMenu = menuList[firstKey];
      
      // 如果有 submenu，跳转到 submenu 的第一个
      if (firstMenu.submenu && firstMenu.submenu.length > 0) {
        this.$router.push({
          name: firstMenu.submenu[0].name
        });
      } else {
        // 否则直接跳转到该路由
        this.$router.push({
          name: firstKey
        });
      }
    },
    // tooltip的可控（解决文字过长的处理）
    visibilityChange(event) {
      const ev = event.target;
      const ev_weight = ev.scrollWidth; // 文本的实际宽度
      const content_weight = ev.clientWidth; // 文本的可视宽度
      if (ev_weight > content_weight) {
        // 文本宽度 > 实际内容宽度  -->内容溢出,则显示悬浮
        this.tooltipFlag = true;
      } else {
        // 否则为未溢出，不显示悬浮
        this.tooltipFlag = false;
      }
    },
    handleOpen(index) {
      // console.log("index", index);
      // console.log("this.role.group", this.role.group);
      // console.log(this.menuList,index,"this.menuList")
      for (let key in this.menuList) {
        if (this.menuList[key].name == index) {
          this.$router.push(
            // '/generalNew/setting/rechargePay'
            `/${this.role.group}New/setting/${this.menuList[key].submenu[0].path}`
          );
        }
      }
      // this.menuList.forEach(element => {
      //   if (element.title == index) {
      //     this.$router.push(
      //       // `/generalNew/setting/${element.children[0].path}`
      //       `/generalNew/setting/${element.submenu[0].path}`
      //     );
      //   }
      // });
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");
.settingSidebarNew {
  .sidebarnew {
    width: 264px;
    height: 100%;
    // min-width: 264px;
    z-index: 2;
  	display: flex;
  	flex-direction: column;
    background: #202D35;
    color: #ffffff;
    border: none;
    padding: 30px;
    .link {
      padding-left: 20px;
      display: flex;
  		align-items: center;
  		cursor: pointer;
      background: #202D35;
      color: rgb(123, 131, 149);
  		&.sublink {
  			padding-left: 20px;
        .title {
          .sc(16px, rgb(123, 131, 149));
        }
        // box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
        border-bottom: 1px solid rgba(198, 209, 221, 0.2);
        margin-top: 10px;
  		}
      .title {
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        .sc(16px, #ffffff);
      }
      .iconfont {
        .sc(20px, #ffffff);
        margin-right: 15px;
      }
      transition: transform 0.3s linear;
      &:hover {
        background: #202D35;
        // .title {
        //   transform: scale(1.05);
        // }
      }
      &.active,
      &.active.router-link-exact-active {
        background: rgb(43, 56, 66);
        border-radius: 8px;
        // box-shadow: 0px 0.5px rgba(198, 209, 221, 0.2);
        .title {
          color: #ffffff;
        }
        i {
          color: #ffffff;
        }
      }
      &.active.sublink,
      &.active.router-link-exact-active.sublink {
        background: #202D35;
        border-radius: 0px;
        .title {
          color: @primaryTextColor;
        }
        .iconfont {
          color: @primaryTextColor;
        }
      }
    }
    /deep/.el-submenu {
      margin-bottom: 30px;
    }
    /deep/.el-menu {
      background: #202D35;
    }
    /deep/.el-menu-item {
      margin-bottom: 30px;
    }
    /deep/.el-menu.el-menu--inline .el-menu-item {
      margin-bottom: 0px;
    }
    /deep/.el-submenu.is-opened .el-submenu__title,
    /deep/.el-submenu.is-opened .el-submenu__title .link {
      background: rgb(43, 56, 66);
      border-radius: 8px;
      // margin-bottom: 10px;
    }
    /deep/.el-submenu__title i {
      color: #ffffff;
    }
    /deep/.el-submenu__title:hover {
      background: #202D35;
    }
    /deep/ .el-submenu__icon-arrow{
      right: auto;
      left: 100%;
    }
  }
}
</style>

